












import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import * as echarts from 'echarts'
@Component({
  name: 'TurnoverStatistics',
})
export default class extends Vue {
  @Prop() private turnoverdata!: any
  @Watch('turnoverdata')
  getData() {
    this.$nextTick(() => {
      this.initChart()
    })
  }
  initChart() {
    type EChartsOption = echarts.EChartsOption
    const chartDom = document.getElementById('main') as any
    const myChart = echarts.init(chartDom)

    var option: any
    option = {
      tooltip: {
        trigger: 'axis',
        backgroundColor: '#fff',
        borderRadius: 8,
        padding: [8, 12],
        textStyle: {
          color: '#333'
        },
        extraCssText: 'box-shadow: 0 2px 12px rgba(0,0,0,0.1)'
      },
      grid: {
        top: '5%',
        left: '3%',
        right: '4%',
        bottom: '8%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        axisLabel: {
          color: '#666',
          fontSize: 12
        },
        axisLine: {
          lineStyle: {
            color: '#eee'
          }
        },
        data: this.turnoverdata.dateList
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          color: '#666',
          fontSize: 12
        },
        splitLine: {
          lineStyle: {
            color: '#f5f5f5'
          }
        }
      },
      series: [
        {
          name: '营业额',
          type: 'line',
          smooth: true,
          symbol: 'circle',
          symbolSize: 8,
          itemStyle: {
            color: '#4caf50'
          },
          lineStyle: {
            width: 3,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#4caf50'
              },
              {
                offset: 1,
                color: '#81c784'
              }
            ])
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: 'rgba(76, 175, 80, 0.3)'
              },
              {
                offset: 1,
                color: 'rgba(76, 175, 80, 0.1)'
              }
            ])
          },
          data: this.turnoverdata.turnoverList
        }
      ]
    }
    option && myChart.setOption(option)
  }
}
